import { addValidationRule } from '@akihirotakamura/formsy-react'
import moment from 'moment'

addValidationRule('isY', (values, value) => {
  if (!value || value === '') return true
  return (
    value.replace(/\u002f/g, '').match(/[0-9]{4}/) &&
    moment(value.replace(/\u002f/g, ''), 'YYYY').isValid()
  )
})
